import { Component, Renderer2, OnInit, OnDestroy, Inject, ViewChild, ElementRef ,Input, OnChanges, Output, EventEmitter } from '@angular/core';

import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { HQProgressHelper } from './hq_progress_helper';
import { downloadAsPDF as _downloadAsPDF } from './../../../helpers/pdf';
import { IndexDbHelper } from 'src/app/helpers/indexDb';
import { authorize } from 'src/app/helpers/AuthorizePage';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { dispatchDateSelectChange } from 'src/app/helpers/tracking';
import { SalesDateService } from '../../elements/sales-date-filter/sales-date-filter.service';
import { UserService } from 'src/app/services/user.services';
import { AnalyticsHelper } from 'src/app/helpers/analytics';

@Component({
  selector: 'app-hq_progress',
  templateUrl: './hq_progress.component.html',
  styleUrls: ['./hq_progress.component.scss'],
  host     : {
    'class': 'se-report-content'
  }
})
export class HQProgressComponent implements OnInit, OnDestroy {
  isDownloadLoading: boolean = false;
  private loadingSubscription: Subscription;
  private salesDateSubscription: Subscription;

  lstAllOptionsData : any;
  ishqLevel1Ready: boolean;
  ishqLevel2Ready: boolean;
  ishqTimelineReady: boolean;

  weeks: any;
  selectedWeek: string;

  fromDate: any;
  toDate: any;
  dateInJobClearCache: string = '';
  lastFilterRange: string = '';
  userGroupName: string = '';
  maxDate: any;
  minDate: any;
  selectedDate: any;
  lstOption_Aggregated_SalesHQLev1: any;

  constructor(private router: Router,public datepipe: DatePipe,
    private salesDateService: SalesDateService,
    private userService: UserService,
    private http: HttpClient) { }

  async ngOnInit() {
    if (!authorize()) {
      this.router.navigateByUrl('unauthorized');
    } else {
      this.userGroupName = this.userService.getUserInfo() || '';
      this.salesDateSubscription = this.salesDateService.getSESalesDate().subscribe((date: string[]) => {
        if (date && date.length > 0) {
          this.dateInJobClearCache = date[0];
          this._getAllFilterOptions();
        }
      });

      this.loadingSubscription = HQProgressHelper.isCsvLoading().subscribe((loading: boolean) => {
        this.isDownloadLoading = loading;
      });
//        AnalyticsHelper.openSweetAlert(`<p class="line1">Important Notice</p><p class="line2">
//        The January 2026 Organization Change has been updated on Sense reports. However, some elements may not be visible yet on KBI Progress Reports. We are verifying the report UI and data and will notify you once the report data verification is complete. We apologize for any inconvenience and appreciate your understanding and cooperation.
// 2026年01月組織再編がSenseのレポートに反映されました。ただし、一部の要素はKBI Progress Reportsにはまだ表示されていない可能性があります。レポートのUIとデータ確認を行っておりますので、完了次第改めてお知らせいたします。ご不便をおかけしますが、ご理解とご協力のほどよろしくお願いいたします。</p>`, false);
    }
  }

  ngOnDestroy(): void {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }

    if (this.salesDateSubscription) {
      this.salesDateSubscription.unsubscribe();
    }
  }

  receive_Aggregated_SalesHQLev1(selected: any){
    this.lstOption_Aggregated_SalesHQLev1 = {keyName : 'SALES_HQ_LEV1_NAME', selectedItems : selected};
  }

  public hqLevel1Ready(ready: boolean){
    this.ishqLevel1Ready = ready;
  }

  public hqLevel2Ready(ready: boolean){
    this.ishqLevel2Ready = ready;
  }

  public hqTimelineReady(ready: boolean){
    this.ishqTimelineReady = ready;
  }

  public onDateTypeSaveItemsChange(event: any) {
    const {selectedSalesDate, isTracking} = event;

    if (isTracking) {
      dispatchDateSelectChange({ ...event, ...{ element: "hq-progress" }, ...{ isDateRange: true } });
    }

    if (selectedSalesDate) {
      this.fromDate = selectedSalesDate[0];
      this.toDate = selectedSalesDate[1];
      this._getAllFilterOptions();
    }
  }

  private _getAllFilterOptions() {
    if (!this.dateInJobClearCache) {
      return;
    }

    // before the user picks a date, use the latest data date so the call is never dateless
    const fromDate = this.fromDate || this.dateInJobClearCache;
    const toDate   = this.toDate || this.dateInJobClearCache;
    const range    = `${fromDate}_${toDate}`;

    if (range === this.lastFilterRange) {
      return;
    }

    this.lastFilterRange = range;

    HQProgressHelper.GetAllFilterOptions(this.http, this.dateInJobClearCache, this.userGroupName, fromDate, toDate).then((data) => {
      this.lstAllOptionsData = data.Filters;
      IndexDbHelper.Set('hqAllOptionsData', data);
    });
  }
}
